import { useState } from 'react';
import { useCreateJob, useUpdateJob } from '../../hooks/useJobs.js';
import { useError } from '../shared/ErrorBanner.jsx';

export default function JobForm({ initial, onDone }) {
  const [name, setName]     = useState(initial?.name || '');
  const [client, setClient] = useState(initial?.client || '');
  const [lat, setLat]       = useState(initial?.site_lat ?? '');
  const [lng, setLng]       = useState(initial?.site_lng ?? '');
  const [radius, setRadius] = useState(initial?.geofence_radius_m ?? 150);
  const create = useCreateJob();
  const update = useUpdateJob();
  const { show } = useError();

  const useCurrent = () => {
    if (!navigator.geolocation) return show('Geolocation unavailable');
    navigator.geolocation.getCurrentPosition(
      p => { setLat(p.coords.latitude); setLng(p.coords.longitude); },
      e => show('Location: ' + e.message),
      { enableHighAccuracy: true, timeout: 8000 },
    );
  };

  const save = async (e) => {
    e.preventDefault();
    const body = {
      name,
      client: client || null,
      site_lat: lat === '' ? null : Number(lat),
      site_lng: lng === '' ? null : Number(lng),
      geofence_radius_m: Number(radius) || 150,
    };
    try {
      if (initial) await update.mutateAsync({ id: initial.id, ...body });
      else await create.mutateAsync(body);
      onDone();
    } catch (err) { show(err.message); }
  };

  const busy = create.isPending || update.isPending;

  return (
    <form onSubmit={save} style={{ marginBottom: 20, padding: 16, background: 'var(--surface-container)' }}>
      <div className="field">
        <label className="field-label">Name</label>
        <input className="field-input" value={name} onChange={e => setName(e.target.value)} required />
      </div>
      <div className="field">
        <label className="field-label">Client</label>
        <input className="field-input" value={client} onChange={e => setClient(e.target.value)} />
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr auto', gap: 8 }}>
        <div className="field">
          <label className="field-label">Lat</label>
          <input className="field-input" value={lat} onChange={e => setLat(e.target.value)} placeholder="optional" />
        </div>
        <div className="field">
          <label className="field-label">Lng</label>
          <input className="field-input" value={lng} onChange={e => setLng(e.target.value)} placeholder="optional" />
        </div>
        <div className="field" style={{ alignSelf: 'end' }}>
          <button type="button" className="btn-sm" onClick={useCurrent}>
            <i className="ph ph-crosshair" /> Here
          </button>
        </div>
      </div>
      <div className="field">
        <label className="field-label">Geofence radius (m)</label>
        <input className="field-input" type="number" min="20" max="2000"
          value={radius} onChange={e => setRadius(e.target.value)} />
      </div>
      <button className="btn-sm primary" type="submit" disabled={busy}>
        {busy ? 'Saving…' : (initial ? 'Update' : 'Create')}
      </button>
    </form>
  );
}
